import firebaseService from '@/services/firebase.service';

export const initAfterLogin = {
    props: {
        i18n: Object,
    },
    methods: {
        getGameTranslation(gameName) {
            switch (gameName) {
                case "Да-нет":
                    return this.$t("games.yesNo");
                case "Кручу-верчу":
                    return this.$t("games.twistingTurning");
                case "Дурак на раздевание":
                    return this.$t("games.theUndressingFool");

                default:
                    return gameName;
            }
        },
        initAfterLogin() {
            // Инициализируем Firebase для push-уведомлений (не блокируем основной поток)
            // Выполняем асинхронно, чтобы не задерживать инициализацию приложения
            firebaseService.init().catch((error) => {
                console.warn('Firebase не инициализирован (не критично):', error);
            });
            
            this.$store
                .dispatch("init/get")
                .then(() => {
                    if (this.init.important_events.length) {
                        let events = this.init.important_events;
                        for (let i in events) {
                            switch (events[i].event_type) {
                                case 17:
                                    this.$modal.show("morda-lenta-win", {
                                        prize: events[i].extra.prize,
                                        count: events[i].extra.count,
                                        combination:
                                            events[i].extra.combination,
                                    });
                                    break;
                                case 18:
                                    this.$modal.show("roulette-result", {
                                        data: events[i].extra,
                                    });
                                    break;
                                case 19:
                                    this.$modal.show("dialog", {
                                        title: this.$t(
                                            "balance.congratulations"
                                        ),
                                        text: events[i].text.format(
                                            this.$t("balance.game") +
                                                "«" +
                                                events[i].extra.game +
                                                "»",
                                            "<b>" +
                                                events[i].extra.prize +
                                                " " +
                                                this.declineNouns(
                                                    events[i].extra.prize,
                                                    [
                                                        this.$t(
                                                            "balanceIn.zarik"
                                                        ),
                                                        this.$t(
                                                            "balanceIn.zarika"
                                                        ),
                                                        this.$t(
                                                            "balanceIn.zarikov"
                                                        ),
                                                    ]
                                                ) +
                                                "</b>"
                                        ),
                                        buttons: [
                                            {
                                                title: this.$t("mixins.ok"),
                                            },
                                        ],
                                    });
                                    break;
                                case 20:
                                    let text = events[i].extra.success
                                        ? this.$t(
                                              "balance.balanceBeenReplenished"
                                          ) +
                                          events[i].extra.amount +
                                          " " +
                                          this.declineNouns(
                                              events[i].extra.amount,
                                              [
                                                  this.$t("balanceIn.zarik"),
                                                  this.$t("balanceIn.zarika"),
                                                  this.$t("balanceIn.zarikov"),
                                              ]
                                          ) +
                                          "!"
                                        : this.$t("balance.paymentDeclined");
                                    this.$modal.show("dialog", {
                                        title: this.$t(
                                            "balance.balanceReplenishment"
                                        ),
                                        text: text,
                                        buttons: [
                                            {
                                                title: this.$t("mixins.ok"),
                                            },
                                        ],
                                    });
                                    break;
                                default:
                                    break;
                            }
                        }
                    }
                    if (this.init.invitation && this.init.invitation.id) {
                        this.$notify({
                            group: "invite",
                            title: this.$t("balance.invitationGame"),

                            text:
                                this.$t("balance.user") +
                                this.init.invitation.from_user.name +
                                this.$t("balance.invitesYouGame") +
                                // this.init.invitation.name +
                                this.getGameTranslation(msg.data.name) +
                                "»",
                            duration: -1,
                            data: {
                                gameId: this.init.invitation.id,
                                lobbyId: this.init.invitation.lobby,
                            },
                        });
                    }
                })
                .catch(() => {});
        },
    },
};
